<!-- 器械采购订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="$common.getFormItemRules(formOneValue, sendDataInfo)">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <df-date class="form_codition" v-if="formOneValue.entityField == 'psomBuydate'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :isdisabled="formOneValue.isChange == 0">
                                                    </df-date>
                                                    <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                                                        :isdisabled="formOneValue.isChange == 0"></df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                                                        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)"
                                                            @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)" v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                                        @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 账期 -->
                                                    <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'" :disabled="formOneValue.isChange == 0"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <!-- string类型 -->
                                                    <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                        :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                                        sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"
                                                    }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <div>
                                        <el-form :inline="true" size="mini">
                                            <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                                                <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="openExtSearch(297457948135424)">提取原单
                                                </el-button>
                                            </div>
                                            <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.pisOrderDetail" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                                                <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                    <template slot-scope="scope">
                                                        <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                            <i class="el-icon-thumb"></i>
                                                        </el-radio>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                    v-for="(formOneValue, formOneKey) in mxForm.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <span v-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="scope.row[formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField])
                                                                }}
                                                            </span>
                                                        </span>
                                                        <el-input v-else-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2" clearable v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]"
                                                            :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                                icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                        <el-input v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2" clearable v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]"
                                                            :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                                icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                        <!-- 退货数量 -->
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" @input="calculatePrice(2, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'rgdRetnumber' && dataActionBox.actionType != 2" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index].rgdRetnumber">
                                                        </el-input>

                                                        <!-- 含税价 -->
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" @input="calculatePrice(2, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 含税金额 -->
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" @input="calculatePrice(4, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2" :maxlength="$store.state.inputLength" type="number"
                                                            v-model.number="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(sendDataInfo.pisOrderDetail[scope.$index][formOneValue.riftField])">
                                                                {{
                                                                    sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]
                                                                }}</a>
                                                        </span>
                                                        <span v-else>{{
                                                            sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]
                                                        }}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionSchemeQc ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog title="维护控销" v-if="showControlPin" :visible.sync="showControlPin" width="70%" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <maintenanceControlPinAciton :mainFormPin="mainFormPin" :actionType="dataActionBox.actionType" :controlGoodTempAdds="controlGoodTempAdds" ref="maintenanceControlPinAciton" @controlPin="getcontrolPin">
            </maintenanceControlPinAciton>
        </el-dialog>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionSchemeQc from "../byComponents/ExtractionSchemeQc.vue";
import maintenanceControlPinAciton from "@/components/maintenanceControlPinAciton.vue";
export default {
    name: "purInitialReturnAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionSchemeQc,
        maintenanceControlPinAciton
    },
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            guaranteeBeginDay: "",
            detailRules: false, //规则
            ruleDisabled: false,
            selectDataTable: false,
            showControlPin: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {
                batchno: '',
                bgiAppnumber: '',
                bgmCode: '',
                bgmId: '',
                bgmName: '',
                bgpUnitmeasurement: '',
                bgsId: '',
                coId: '',
                coName: '',
                expidate: '',
                inRate: '',
                lotno: '',
                lowestPrice: '',
                manufacturer: '',
                money: '',
                ormName: '',
                outRate: '',
                packingSpec: '',
                placeorigin: '',
                price: '',
                prodate: '',
                psmoney: '',
                psprice: '',
                spec: '',
                stId: '',
                stName: '',
                sterBatchno: '',
                stockNum: '',
                psodReserves1: "",
                psodReserves2: "",
                psodReserves3: "",
                psodReserves4: "",
                psodReserves5: "",
                psodReserves6: "",

            },
            selectedDetailsIndex: 0,
            value1: "",
            sendDataInfo: {
                rgamRapdate: "",
                coName: "",
                coId: "",
                payMethod: "",
                settleMethod: "",
                psaiAccperiod: "",
                psaiCarricus: "",
                psaiCarrier: "",
                psaiDeptime: "",
                psaiExptime: "",
                psaiPaymethod: "",
                psaiReserves1: "",
                psaiReserves2: "",
                psaiReserves3: "",
                psaiReserves4: "",
                psaiReserves5: "",
                psaiReserves6: "",
                psaiSettmethod: "",
                pisOrderDetail: [],
                controlGoodTempAdds: [],
                psomBusdept: 0,
                smId: 0,
                smName: "",
                psomBuydate: 0,
                psomBuydateval: 0,
                isWms: "",
                opmId: 0,
                opmName: "",
                psomRemark: "",
                psomReserves1: "",
                psomReserves2: "",
                psomReserves3: "",
                psomReserves4: "",
                psomReserves5: "",
                psomReserves6: "",
                salesId: "",
                salesName: "",
                totalCount: 0,
                totalMoney: 0,
                totalNumber: 0,
                psaiId: "",
                psomId: "",
                depId: "",
                depName: "",
                isPay: "",
                sbiName: "",
                sbiNumber: "",
                sbiId: "",
                psbkmId: '',
                saiAddress: '',
                caild: ''
                // spec: '',
                // manufacturer: '',
                // scopeName: '',
                // placeorigin: '',
                // mne: '',
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            editDateilsIndex: "",
            exId: "",
            ppId: "orderId",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
                orderType: 1, //	订单类型0.药品1.器械
            },
            isLoaded: false,
            orderId: "",
            printsouce: "",
            seIndex: 0, //选中索引
            isBuyer: 0,
            tabForm: [], // tab循环的主表单
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            mxForm: [],
            footForm: [],
            selectedRow: [],
            mainFormPin: [], //维护控销数据
            controlGoodTempAdds: [], //
            stNameFlag: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.pisOrderDetail": {
            handler: function (newValue, oldValue) {
                console.log(newValue);
                this.ruleDisabled = newValue?.length > 0 ? true : false;
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.totalNumber = 0;
                this.sendDataInfo.totalCount = 0;
                newValue.forEach((item, keys) => {
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'rgdOldnumber', this.$common.updataNum('rgdOldnumber', item).rgdOldnumber)
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'rgdRetnumber', this.$common.updataNum('rgdRetnumber', item).rgdRetnumber)
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'price', this.$common.updataNum('price', item).price)
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'money', this.$common.updataNum('money', item).money)
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'psprice', this.$common.updataNum('psprice', item).psprice)
                    this.$set(this.sendDataInfo.pisOrderDetail[keys], 'psmoney', this.$common.updataNum('psmoney', item).psmoney)
                    if (item.price < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].price = 0;
                        return false;
                    }
                    if (item.money < 0) {
                        this.sendDataInfo["pisOrderDetail"][keys].money = 0;
                        return false;
                    }
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, Number(this.sendDataInfo.totalMoney) + Number(item.psmoney) || 0)
                    this.sendDataInfo.totalNumber = NP.round((Number(this.sendDataInfo.totalNumber) + Number(item.rgdRetnumber) || 0), 2)
                });

                console.log(newValue)
                this.sendDataInfo.totalCount = newValue.length;
                this.mainFormPin = this.sendDataInfo;
                this.mainFormPin = JSON.parse(JSON.stringify(this.mainFormPin));
            },
            deep: true,
            immediate: true

        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.parentSearchData.smId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.isPay": {
            handler: function (newValue, oldValue) {
                console.log(newValue);
                if (newValue == 0) {
                    this.sendDataInfo.sbiName = "";
                    this.sendDataInfo.sbiId = "";
                    this.sendDataInfo.sbiNumber = "";
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 0;
                        }
                    });
                } else {
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 1;
                        }
                    });
                }
                this.$forceUpdate();
            },
            deep: true,
        },
        "parentSearchData.smId": {
            handler: function (newValue, oldValue) {
                console.log("smId=======", newValue);
            },
            deep: true,
        },
        "sendDataInfo.dismode": {
            handler: function (newstr, oldValue) {
                this.$nextTick(() => {
                    let newValue = newstr.replace(/\s*/g, "");
                    this.sendDataInfo.dismode = newValue
                    if (newValue != "物流" || newValue == '') {
                        this.sendDataInfo.companyName = ''
                        this.sendDataInfo.loId = ''
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 0;
                            }
                        })

                    } else {
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 1;
                            }
                        });
                    }

                })
                this.some++
                this.$forceUpdate();
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        tabHeight(val) {
            this.mxHeight = val
        },
        //触发提取
        openExtSearch(id) {

            this.exId = id;
            this.ppId = 'psbkmId'
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            console.log('提取', val)
            if (val != "" || val != undefined) {
                if (this.sendDataInfo.smId && this.sendDataInfo.smId !== val.smId) return this.$message({ message: "请提取相同供货单位的单据", type: "error", });
                console.log(1)
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        if (this.exId == '949599709200712') {
                            // this.sendDataInfo.pisOrderDetail = [];
                            // this.sendDataInfo.pisOrderDetail = val.arrlistbychen;  //要求能看明细但不提取
                        } else {
                            this.sendDataInfo.pisOrderDetail = val.arrlistbychen;
                            this.sendDataInfo.pisOrderDetail.forEach((v, i) => {
                                // this.calculatePrice(2, i)
                            })
                        }
                    } else {


                    }
                }
                this.sendDataInfo.psbkmId = val.accountId
                this.sendDataInfo.pscamId = val.accountId
                this.sendDataInfo.coName = val.coName
                this.sendDataInfo.smName = val.smName
                this.sendDataInfo.smId = val.smId
                this.sendDataInfo.coId = val.coId
                this.sendDataInfo.rgamRemark = val.rgamRemark
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.totalNumber = 0
                this.sendDataInfo.totalCount = 0
                console.log(this.sendDataInfo.pisOrderDetail)
                // this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]);
                    this.nextFocus(0)
                })
            }
        },
        // 获取控销保存数据
        async getcontrolPin(value) {
            console.log(value, 'getcontrolPin')
            this.controlGoodTempAdds = value
            if (this.controlGoodTempAdds.length > 0) {
                this.showControlPin = false
            }
        },
        // 维护控销
        // editControlpin(sendDataInfo) {
        //    this.$refs[sendDataInfo][0].validate((valid) => {
        //       if (valid) {
        //          if (this.sendDataInfo.pisOrderDetail.length < 1) {
        //             this.$message({
        //                message: "请添加采购订单明细",
        //                type: "error",
        //             });
        //             return;
        //          } else {
        //             this.showControlPin = true;
        //          }
        //       } else {
        //          return this.$message({
        //             message: "请完善必填信息",
        //             type: "warning",
        //          });
        //       }
        //    });
        // },
        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.smId == "") {
                return this.$message({
                    message: "请先选择供货单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.smId);
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            console.log(index);
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.pisOrderDetail.length > 0) {
                }
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == "keydown") {
                if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    return;
                }
                this.addDetail("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log(this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },
        // 表格赋值字段
        mxParamValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo.pisOrderDetail[this.seIndex][item] = val[item];
            });
            this.$nextTick(() => {
                this.tableNextFocus(this.fField, this.seIndex);
            });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                addEventListener("keyup", this.keyUp); //创建监听键盘事件
                if (val.depId) {
                    this.sendDataInfo.depId = val.depId;
                    this.sendDataInfo.depName = val.depName;
                }
                if (this.seType == "bgmName") {
                    for (let key in val) {
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex][key] = val[key]
                    }
                    this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex].rgdRetnumber = 0
                    this.tableNextFocus(this.fField, this.seIndex)
                } else if (this.seType == "smName") {
                    this.sendDataInfo.smName = val.smName;
                    this.sendDataInfo.smId = val.smId;
                    this.$http.queryDefaultSales({
                        ids: [val.smId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            var valObj = {
                                ...val,
                                ...res.result,
                            }
                            if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                this.$http
                                    .checkVendorLicense({
                                        //校验购进单位
                                        formId: this.formDataList[0].jciId, //表单ID
                                        unitId: val.smId, //单位ID
                                    })
                                    .then((res) => {
                                        if (res && res.status == 200) {
                                            this.parentSearchData.smId = val.smId;
                                            this.paramValue(val);
                                        } else if (res && res.status == 300) {
                                            this.lineMessageBox(res);
                                            this.parentSearchData.smId = val.smId;
                                            this.paramValue(val);
                                        } else {
                                            this.lineMessageBox(res);
                                            this.parentSearchData.smId = "";
                                            this.clearValue();
                                            return false;
                                        }
                                    })
                                    .catch((rej) => {
                                        this.lineMessageBox(rej);
                                        this.parentSearchData.smId = "";
                                        this.clearValue();
                                    });
                            } else {
                                this.paramValue(val);
                            }
                        } else {
                            this.paramValue(val);
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                    });

                } else if (this.seType == "salesName") {
                    this.$http
                        .checkSalesLicense({
                            //校验供应商业务员
                            formId: this.formDataList[0].jciId, //表单ID
                            salesId: val.salesId, //业务员ID
                        })
                        .then((res) => {
                            if (res && res.status == 200) {
                                this.paramValue(val);
                            } else if (res && res.status == 300) {
                                this.lineMessageBox(res);

                                this.paramValue(val);
                            } else {
                                this.lineMessageBox(res);

                                this.clearValue();
                                return false;
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);

                            this.clearValue();
                        });
                } else if (this.seType == "stName") {
                    if (this.stNameFlag) {
                        this.mxParamValue(val);
                    } else {
                        this.paramValue(val);
                    }
                } else if (this.seType == "lotno") {
                    for (let key in val) {
                        if (key == "price") {
                            val[key] = this.$common.getDecimalInfo(2, val[key])
                        }
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex][key] = val[key];
                    }
                    this.sendDataInfo.pisOrderDetail.forEach((v, i) => {
                        this.calculatePrice(2, i)
                    })
                }
                else {
                    this.paramValue(val);
                }
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
            // this.changeFocus();
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            console.log(sId, type)
            if (
                type == "salesName" ||
                type == "caiAddress" ||
                type == "recName" ||
                type == "sbiName"
            ) {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            if (type == "stName") {
                if (flag) {
                    this.stNameFlag = flag
                    this.parentSearchData.stName = this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex].stName;
                } else {
                    this.stNameFlag = false
                    this.parentSearchData.stName = this.sendDataInfo.stName;
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            if (type == "bgmName") {
                this.parentSearchData.stId = this.sendDataInfo.stId;
                this.parentSearchData.cmId = this.sendDataInfo.cmId;
                this.parentSearchData.outcoId = this.sendDataInfo.coId;
                this.parentSearchData.bgmName = this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName;
                return;
            }
            if (type == "salesName") {
                this.parentSearchData.smId = this.sendDataInfo.smId;
            }
            if (type == 'lotno') {
                for (let key in this.sendDataInfo.pisOrderDetail[index]) {
                    this.parentSearchData[key] = this.sendDataInfo.pisOrderDetail[index][key]
                }
                this.parentSearchData.coId = this.sendDataInfo.coId
                return
            }
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false
            if (this.sendDataInfo.pisOrderDetail.length > 0) {
                this.sendDataInfo.pisOrderDetail.forEach(item => {
                    if (item.bgmId == "") {
                        flag = true
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                })
            }
            if (flag) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.pisOrderDetail.push(
                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                    );
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.pisOrderDetail.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        detailsAction(cate = 0) {
            if (cate == 0) {
                this.editDateilsIndex = "";
                return false;
            }

            var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
            if (dataInfo.psodPacknum <= 0) {
                this.$message({
                    message: "请填写退货数量",
                    type: "error",
                });
                return false;
            }
            if (this.editDateilsIndex !== "") {
                this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1);
            }
            this.sendDataInfo.pisOrderDetail.push(dataInfo);
            this.editDateilsIndex = "";
        },
        // 计算税率乘数
        calculateTaxMultiplier(info) {
            const taxRate = info.inRate ? NP.divide(info.inRate, 100) : 0;
            return NP.plus(taxRate, 1);
        },

        // 计算价格
        calculatePrice(cate, index, flag) {
            var info = this.sendDataInfo.pisOrderDetail[index];

            // 优化条件判断，修复逻辑错误 (info.rgdRetnumber <= 0 && info.rgdRetnumber == undefined 总是false)
            if (!info.rgdRetnumber && info.rgdRetnumber !== 0) {
                this.$message({
                    message: "请先填写退货数量",
                    type: "error",
                });
                return false;
            } else if (info.rgdRetnumber > info.stockNum) {
                this.sendDataInfo.pisOrderDetail[index].rgdRetnumber = info.stockNum;
                if (!flag) {
                    this.calculatePrice(cate, index, true);
                }
                return this.$message({
                    message: "退货数量不能大于库存数量",
                    type: "error",
                });
            }

            const taxMultiplier = this.calculateTaxMultiplier(info);
            const quantity = info.rgdRetnumber;
            const safeQuantity = quantity === 0 ? 1 : quantity; // 避免除以0

            switch (cate) {
                case 2: // 含税价格计算
                    // 计算含税金额 含税价格*数量
                    const calculatedPsmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
                    this.sendDataInfo.pisOrderDetail[index].psmoney = calculatedPsmoney;

                    // 计算不含税金额
                    const midmoney = this.$common.getDecimalInfo(3, NP.divide(calculatedPsmoney, taxMultiplier));
                    this.sendDataInfo.pisOrderDetail[index].money = midmoney;

                    // 计算不含税单价
                    const calculatedPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, safeQuantity));
                    this.sendDataInfo.pisOrderDetail[index].price = calculatedPrice;

                    // 计算税额
                    const calculatedTaxAmount = this.$common.getDecimalInfo(3, NP.minus(calculatedPsmoney, midmoney));
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = calculatedTaxAmount;
                    break;

                case 4: // 通过含税金额计算
                    // 计算总金额 含税金额/(税率/100+1)
                    const midmoney4 = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, taxMultiplier));
                    this.sendDataInfo.pisOrderDetail[index].money = midmoney4;

                    // 计算单价 金额/数量
                    const calculatedPrice4 = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney4, safeQuantity));
                    this.sendDataInfo.pisOrderDetail[index].price = calculatedPrice4;

                    // 计算含税价格  含税金额 / 数量
                    const calculatedPsprice4 = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.psmoney, safeQuantity));
                    this.sendDataInfo.pisOrderDetail[index].psprice = calculatedPsprice4;

                    // 计算税额
                    const calculatedTaxAmount4 = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, midmoney4));
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = calculatedTaxAmount4;
                    break;

                default:
                    // 通过数量计算 (与case 2相同逻辑)
                    const calculatedPsmoney2 = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
                    this.sendDataInfo.pisOrderDetail[index].psmoney = calculatedPsmoney2;

                    // 计算总金额 含税金额/(税率/100+1)
                    const midmoney2 = this.$common.getDecimalInfo(3, NP.divide(calculatedPsmoney2, taxMultiplier));
                    this.sendDataInfo.pisOrderDetail[index].money = midmoney2;

                    // 计算单价 金额/数量
                    const calculatedPrice2 = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney2, safeQuantity));
                    this.sendDataInfo.pisOrderDetail[index].price = calculatedPrice2;

                    // 计算整件数量
                    const packingSpec = Number(info.packingSpec);
                    this.sendDataInfo.pisOrderDetail[index].wholeNum = Math.floor(NP.divide(quantity, packingSpec));

                    // 计算零散数量
                    const wholeNumTimesPackingSpec = NP.times(this.sendDataInfo.pisOrderDetail[index].wholeNum, packingSpec);
                    this.sendDataInfo.pisOrderDetail[index].scatNum = NP.minus(quantity, wholeNumTimesPackingSpec);

                    // 计算税额
                    const calculatedTaxAmount2 = this.$common.getDecimalInfo(3, NP.minus(calculatedPsmoney2, midmoney2));
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = calculatedTaxAmount2;

                    // 计算件数 采数/包装单位
                    const isValidPackingSpec = parseFloat(info.packingSpec) > 0 && info.packingSpec !== "";
                    this.sendDataInfo.pisOrderDetail[index].pieceNum = isValidPackingSpec
                        ? this.$common.getDecimalInfo(1, NP.divide(quantity, info.packingSpec))
                        : 0;
                    break;
            }
        },
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                    this.mainFormPin = []
                    sessionStorage.removeItem('setPin1')
                    sessionStorage.removeItem('allAndself')
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinf") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

            this.sendDataInfo.pisOrderDetail = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.orderType = 1; //orderType	订单类型0.药品订单1.器械订单
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.psomBusdept = item.depId;
                }
            });
        },
        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.smId = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    this.sendDataInfo.salesId = "";
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        changeFocus() {
            setTimeout(() => {
                var el = document.getElementById("mainInfo");

                var inel = el.getElementsByClassName("el-input__inner");
                for (let index = 0; index < inel.length; index++) {
                    if (inel[index].value == "") {
                        console.log(inel[index]);
                        inel[index].focus();
                        break;
                    }
                }
            }, 500);
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;

            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.smId = "";
                this.initDefaultValue();
                this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
                this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
                this.sendDataInfo.psaiExptime = this.$moment().valueOf();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.smId = dataInfo.smId;
                this.parentSearchData.smId = oldData.smId;
                this.sendDataInfo.pisOrderDetail = dataInfo.rgapplydetailInfos
                this.sendDataInfo.pscamId = dataInfo.psbkmId

            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])

                }
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 100)
            });
            this.changeFocus();
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay);
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
            this.sendDataInfo.psomBuydate = this.$moment().valueOf();
            this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
            this.sendDataInfo.psaiExptime = this.$moment().valueOf();
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.detaislDataInfo, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "")
                            })
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "")
                        }
                    })
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (
                        key.jurconfigform[index].isShow == 1 ||
                        key.jurconfigform[index].entityField == "sbiName" ||
                        key.jurconfigform[index].entityField == "sbiNumber"
                    )
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "pisOrderDetail" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        //确认新增
        sendDataAction(formName1) {
            console.log('sendDataInfo', this.sendDataInfo)
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        async sub() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                this.$message({
                    message: "请添加采购订单明细",
                    type: "error",
                });
                return;
            }
            var flagNum = false
            var flag = false
            var flagPsmoney = false
            var flagMoney = false
            var flagPrice = false
            var indexNum = 0
            var indexNum1 = 0
            var indexNum2 = 0
            var indexNum3 = 0
            var indexNum4 = 0
            this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                if ((item.rgdRetnumber == "" || item.rgdRetnumber == null || item.rgdRetnumber <= 0) && !flagNum) {
                    indexNum3 = index
                    flagNum = true
                }
                if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {
                    if (this.$common.getDecimalInfo(3, (item.psprice * item.rgdRetnumber)) != item.psmoney && !flagPsmoney) {
                        indexNum = index
                        flagPsmoney = true
                    }
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(item.psmoney, NP.plus(NP.divide((item.inRate || 0), 100), 1)))
                    if (this.$common.getDecimalInfo(3, midmoney) != item.money && !flagMoney) {
                        indexNum1 = index
                        flagMoney = true
                    }
                    if (this.$common.getDecimalInfo(2, NP.divide(midmoney, item.rgdRetnumber)) != item.price && !flagPrice) {
                        indexNum2 = index
                        flagPrice = true
                    }
                } else if (!flag) {
                    indexNum4 = index
                    flag = true
                }
            })
            if (flagNum) {
                return this.$message.error(`第${indexNum3 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum3].bgmName}数量不能为空或为零！`)
            }
            if (flagPsmoney) {
                return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum].bgmName}含税金额计算规则不符！`)
            }
            if (flagMoney) {
                return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum1].bgmName}金额计算规则不符！`)
            }
            if (flagPrice) {
                return this.$message.error(`第${indexNum2 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum2].bgmName}价格计算规则不符！`)
            }
            if (flag) {
                return this.$message.error(`第${indexNum4 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum4].bgmName}（含税价格、含税金额、价格、金额）有为零的请检查！`)
            }
            this.sendDataInfo.rgapplydetailInfos = JSON.parse(JSON.stringify(this.sendDataInfo.pisOrderDetail))
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addQcRg(
                    this.sendDataInfo
                );
            } else {
                var responseData = await this.$http.updatePurchaseOrder(
                    this.sendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
                this.mainFormPin = []
                sessionStorage.removeItem('setPin1')
                sessionStorage.removeItem('allAndself')
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
                return false;
            }

            // this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            // this.selectedDetailsIndex = 0;

            this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.pisOrderDetail.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
            // this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
                this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            );
        },
        // 复制
        copyDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可复制明细",
                    type: "warning",
                });
                return false;
            } else {
                this.sendDataInfo.pisOrderDetail.push(
                    JSON.parse(
                        JSON.stringify(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        )
                    )
                );
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmBuyer == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.pisOrderDetail.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.pisOrderDetail.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.checkIsBuyer();
            this.isLoaded = true;
        });
        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
 
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}
</style>
<style>
.el-table .cell,
.el-table--border .el-table__cell:first-child .cell {
    color: rgba(0, 0, 0, 1);
    font-weight: 500;
}
</style>